abstract class State {

}

export default State;